import { Component, OnInit, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Router, RouterModule } from '@angular/router';
import { Button } from 'ustore-ui';

import { I18nPipe } from '../../shared/pipes/i18n.pipe';
import { OrderPartialErrorService, OrderPartialErrorData } from '../../core/services/order-partial-error.service';

@Component({
  selector: 'umkt-order-partial-error',
  standalone: true,
  imports: [CommonModule, RouterModule, Button, I18nPipe],
  templateUrl: './order-partial-error.component.html',
  styleUrls: ['./order-partial-error.component.scss'],
})
export class OrderPartialErrorComponent implements OnInit {
  data: OrderPartialErrorData | null = null;
  private router = inject(Router);
  private orderPartialErrorService = inject(OrderPartialErrorService);


  ngOnInit(): void {
    this.data = this.orderPartialErrorService.getPartialError();
    if (!this.data?.failedProducts?.length) {
      this.router.navigate(['/']);
    }
  }

  goToCheckout(): void {
    this.router.navigate(['/checkout']);
  }

  goToHome(): void {
    this.router.navigate(['/']);
  }

  goToMyOrders(): void {
    this.router.navigate(['/my-account/orders']);
  }

  trackByIndex(index: number): number {
    return index;
  }
}
